module.exports = __webpack_public_path__ + "static/img/shebei1.ee92c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shebei1.png
// module id = Rz7j
// module chunks = 1